import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';

import StyledBackButton from '../styledBackButton';
import { INTAKE_LOGIN_ROUTE } from './../../../constants/intakeConstants';
import StyledButton from '../../common/Button';

import ForgotSuccess from '../../../assets/icons/forgot-success.png';
import {
  ForgotSuccessContainer,
  ForgotSuccessWrapper,
} from '../intake-forgot/intakeForgot.styles';

const IntakeResetSuccess = () => {
  const history = useHistory();

  const backNavigate = () => {
    history.push(INTAKE_LOGIN_ROUTE);
  };

  useEffect(() => {
    setTimeout(() => {
      history.push(INTAKE_LOGIN_ROUTE);
    }, 2000);
  }, []);

  return (
    <ForgotSuccessContainer>
      <ForgotSuccessWrapper>
        <Grid container sx={{ position: 'relative' }}>
          <Grid item xs={12} className='forgot-success-section'>
            <Box sx={{ position: 'absolute', top: '0', left: '0' }}>
              <StyledBackButton onClick={backNavigate} />
            </Box>
            <div className='success-container'>
              <div className='success-wrapper'>
                <div className='img-container'>
                  <img src={ForgotSuccess} alt='Reset password success' />
                </div>
                <Typography
                  variant='h3'
                  className='header forgot-success-header'
                >
                  Success
                </Typography>
                <Typography
                  variant='body1'
                  className='title forgot-success-title'
                >
                  Your password changed successfully!
                </Typography>
                <Box sx={{ textAlign: 'center' }}>
                  <StyledButton
                    variant='contained'
                    fullWidth={false}
                    value='SIGN IN'
                  />
                </Box>
              </div>
            </div>
          </Grid>
        </Grid>
      </ForgotSuccessWrapper>
    </ForgotSuccessContainer>
  );
};

export default IntakeResetSuccess;
